import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Indicator,
} from "@hulahoop/ui";
import { FunnelSimple } from "@phosphor-icons/react";
import { IconTooltip } from "./IconTooltip";
import type { CommentsLabels } from "@/domain/types/commentsLabels";

export function CommentsScopeMenu({
  status,
  onStatus,
  openCount,
  resolvedCount,
  mode,
  onMode,
  labels,
}: {
  status: "open" | "resolved";
  onStatus: (value: "open" | "resolved") => void;
  openCount: number;
  resolvedCount: number;
  mode?: "all" | "page";
  onMode: (value: "all" | "page") => void;
  labels: CommentsLabels;
}) {
  const active = status !== "open" || mode === "page";
  return (
    <DropdownMenu>
      <IconTooltip label={labels.filter}>
        <DropdownMenuTrigger
          render={
            <Button variant="ghost" size="icon-sm" aria-label={labels.filter} nativeButton>
              {active ? (
                <Indicator label={labels.filter_active}>
                  <FunnelSimple />
                </Indicator>
              ) : (
                <FunnelSimple />
              )}
            </Button>
          }
        />
      </IconTooltip>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          {mode && <DropdownMenuLabel>{labels.state}</DropdownMenuLabel>}
          <DropdownMenuRadioGroup
            value={status}
            onValueChange={(value) => onStatus(value === "resolved" ? "resolved" : "open")}
          >
            <DropdownMenuRadioItem value="open" className="tabular-nums">
              {labels.open} · {openCount}
            </DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="resolved" className="tabular-nums">
              {labels.resolved} · {resolvedCount}
            </DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuGroup>
        {mode && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuLabel>{labels.scope}</DropdownMenuLabel>
              <DropdownMenuRadioGroup
                value={mode}
                onValueChange={(value) => onMode(value === "page" ? "page" : "all")}
              >
                <DropdownMenuRadioItem value="all">{labels.all}</DropdownMenuRadioItem>
                <DropdownMenuRadioItem value="page">{labels.page}</DropdownMenuRadioItem>
              </DropdownMenuRadioGroup>
            </DropdownMenuGroup>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
